(function($) { $(document).ready(function() {

    if ($(".why-we-do-this-section").length > 0) {
        let box = $(".why-we-do-this-box");

        box.on('click', on_click_box);

        /**
         * Boxes on desktop
         */
        function on_click_box (){
            let $this = $(this);

            box.each(function(){
                $(this).removeClass('bg-white');
            });

            $(this).addClass('bg-white');

            $('.why-we-do-this-icon').animate({'opacity': 0}, 200, function(){
                $(this).html('<i class="' + $this.attr('data-icon') + ' text-5xl 4xl:text-6xl text-verdilaborange"></i>').animate({'opacity': 1}, 200);
            });

            $('.why-we-do-this-title').animate({'opacity': 0}, 200, function(){
                $(this).html('<span>' + $this.find('span').html() + '</span>').animate({'opacity': 1}, 200);
            });

            $('.why-we-do-this-description').animate({'opacity': 0}, 200, function(){
                $(this).html($this.find('.why-we-do-this-box-description').html()).animate({'opacity': .6}, 200);
            });

            const url = new URL(window.location.href);
            url.searchParams.set('why-we-do-this', $this.attr('data-url'));
            window.history.replaceState(null, null, url); // or pushState
        }

        /**
         * Accordion on mobile
         */
        $('.why-do-this-accordion .toggle').click(function(e) {
            e.preventDefault();

            var $this = $(this);

            $('.why-do-this-accordion .toggle').each(function(){
                $(this).removeClass('showing');
            });

            if ($this.next().hasClass('hidden')) {
                $this.next().removeClass('hidden');
                $this.next().slideUp(200);
                $this.parent().find('.icon-arrow-small-down').removeClass('rotate-180');
                $this.removeClass('showing');
            } else {
                $this.parent().parent().find('li .inner').removeClass('hidden');
                $this.parent().parent().find('li .inner').slideUp(200);
                $this.parent().find('.icon-arrow-small-down').addClass('rotate-180');
                $this.next().toggleClass('hidden');
                $this.next().slideToggle(200);
                $this.addClass('showing');
            }
        });

        /**
         * URL Parameter checker
         */
        let searchParams = new URLSearchParams(window.location.search);
        if(searchParams.has('why-we-do-this') ){
            $('.why-we-do-this-box').parent().find(`[data-url='${searchParams.get('why-we-do-this')}']`).click();
            $('html,body').animate({
                scrollTop: $('.why-we-do-this-box').parent().offset().top - 100
            }, 500);
        } else {
            $('.why-we-do-this-box').first().click();
        }
    }
}); })( jQuery );